// Piezas de formulario de los editores maestro-detalle: secciones, títulos, etiquetas y mensajes.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Etiqueta de campo en mayúsculas (`.form-field label` del mock). */
export const FIELD_LABEL =
    'mb-1 block text-[10px] font-bold uppercase tracking-[0.04em] text-muted-foreground';

/** Campo de texto del editor (`.form-field input` del mock). */
export const FIELD_INPUT =
    'w-full rounded-[5px] border border-border bg-background px-[9px] py-1.5 text-xs text-foreground outline-none focus:border-ring focus:ring-2 focus:ring-ring/15 disabled:opacity-60 aria-[invalid=true]:border-destructive';

/** Bloque del editor separado por una línea tenue (`.section` del mock). */
export const SECTION = 'mb-3.5 border-b border-border/50 pb-3.5';

/** Clases del título de sección, para quien no puede usar `<SectionTitle>`. */
export const SECTION_TITLE_CLASS =
    'mb-2 text-[10.5px] font-bold uppercase tracking-[0.06em] text-muted-foreground';

/** Clases del mensaje de error bajo un campo. */
export const FIELD_MESSAGE_CLASS = 'mt-1 text-[10.5px] text-destructive';

export function SectionTitle({ children, className }: { children: ReactNode; className?: string }) {
    return <h3 className={cn(SECTION_TITLE_CLASS, className)}>{children}</h3>;
}

/** Resumen calculado bajo un bloque (`.sec-live-inline` del mock). */
export function LiveInline({ children, className }: { children: ReactNode; className?: string }) {
    return (
        <div
            className={cn(
                'mt-1.5 flex items-center gap-1.5 text-[10.5px] tabular-nums text-muted-foreground',
                className,
            )}
        >
            {children}
        </div>
    );
}

/** La unidad junto a un campo (`.pal-inputs .u` del mock). */
export function Unit({ children }: { children: ReactNode }) {
    return <span className="text-[10.5px] text-muted-foreground">{children}</span>;
}

export function FieldMessage({ message }: { message: string | undefined }) {
    if (!message) return null;
    return <p className={FIELD_MESSAGE_CLASS}>{message}</p>;
}
